import React from 'react';
import styled from 'styled-components';
import { Body1, H1 } from '@ui';
import { SplashSectionWrapper } from './styles';

const SectionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 1060px) {
    display: block;
  }
`;
const HeadingWrapper = styled.div`
  padding-bottom: 36px;
  text-align: left;
  width: 100%;

  h1 {
    font-size: 48px;
    line-height: 64px;
    letter-spacing: -3px;
  }

  @media (max-width: 710px) {
    h1 {
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -1px;
    }
  }
`;
const DescriptionWrapper = styled.div`
  padding: 24px 0 0 0;
  max-width: 500px;

  @media (max-width: 1060px) {
    max-width: 80vw;
  }
`;
const CodeBlock = styled.pre`
  line-height: 1.6;
  padding: 20px 24px;
  overflow-x: auto;
  color: #e6e6e6;
  font-family: 'Fira Mono', 'Menlo', 'Monaco', 'Consolas', monospace;
  font-size: 15px;
`;
const CodeSectionWrapper = styled.div`
  width: 45vw;
  min-height: 540px;
  background: #222;
  padding: 20px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  @media (max-width: 1060px) {
    margin-top: 24px;
    width: 80vw;
  }

  @media (max-width: 710px) {
    margin-top: 24px;
    width: 100%;
  }
`;
const TabWrapper = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: 0;
`;
const TabButton = styled.button`
  background: ${({ active }) => (active ? '#222' : '#222')};
  color: #e6e6e6;
  border: none;
  border-radius: 8px 8px 0 0;
  padding: 8px 20px;
  font-size: 15px;
  font-family: inherit;
  cursor: pointer;
  outline: none;
  margin-right: 2px;
  transition: background 0.15s;
  border-bottom: ${({ active }) => (active ? '2px solid #fcff7d' : '2px solid transparent')};
  &:hover {
    background: #000;
  }
`;

const codeSnippets = {
  curl: `curl -X GET "https://api.tornado.com/api/v1/genai/documents?category=company&tickers=AAPL"  \\
  -H "access-token: YOUR_ACCESS_TOKEN" \\
  -H "Content-Type: application/json" \\
  -H "Accept: application/json"`,

  python: `import requests

url = "https://api.tornado.com/api/v1/genai/documents"
headers = {
    "access-token": "YOUR_ACCESS_TOKEN",
    "Content-Type": "application/json",
    "Accept": "application/json"
}
params = {
    "category": "company",
    "tickers": "AAPL"
}

response = requests.get(url, headers=headers, params=params)
print(response.json())`,
};

const ExampleCurl = () => {
  const [tab, setTab] = React.useState('curl');

  return (
    <CodeSectionWrapper>
      <TabWrapper>
        <TabButton active={tab === 'curl'} onClick={() => setTab('curl')}>
          cURL
        </TabButton>
        <TabButton active={tab === 'python'} onClick={() => setTab('python')}>
          Python
        </TabButton>
      </TabWrapper>
      <CodeBlock>{codeSnippets[tab]}</CodeBlock>
    </CodeSectionWrapper>
  );
};

export const ApiFeature = () => {
  return (
    <SplashSectionWrapper>
      <HeadingWrapper>
        <SectionsWrapper>
          <div style={{ flex: 1 }}>
            <H1>API-first approach</H1>
            <DescriptionWrapper>
              <Body1>
                Our API-first approach allows you to connect to your existing data and use our AI-powered platform to
                unlock powerful insights, streamline workflows, and drive smarter decisions with AI.
              </Body1>
            </DescriptionWrapper>
          </div>
          <ExampleCurl />
        </SectionsWrapper>
      </HeadingWrapper>
    </SplashSectionWrapper>
  );
};
